const startPage: Record<string, Record<string, string> | string> = {
    productName: 'Модуль Экспертизы',
    productDescription: 'Автоматизация процесса проведения независимой экспертизы',
};

export default startPage;
